module.exports = "<chart type=\"StockChart\" [options]=\"options\" (load)=\"saveInstance($event.context)\"></chart>\n"


//////////////////
// WEBPACK FOOTER
// /home/travis/build/nishant95/stocks-app/src/app/modules/highstock-chart/highstock-chart.component.html
// module id = ../../../../../src/app/modules/highstock-chart/highstock-chart.component.html
// module chunks = main